import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';
import { pinia } from '@/js/lib/store';
import { useEventStore } from '@/js/lib/store/event';
import { addFollowButton } from '@/js/lib/ui/follow-button';
import SocialShare from '@/js/components/common/ui/share.vue';
import PhotoViewer from '@/js/components/www.iichi.com/organisms/PhotoViewer.vue';
import EventLikeButton from '@/js/components/www.iichi.com/pages/event/eventLikeButton.vue';

const eventStore = useEventStore(pinia);

document.addEventListener('DOMContentLoaded', async () => {
  if ('customElements' in window) {
    const photoViewerEl = document.querySelector('photo-viewer') as HTMLElement;
    createApp({
      render: () =>
        h(PhotoViewer, {
          pictures: JSON.parse(photoViewerEl.dataset.pictures!) as {
            path: string;
            width: number;
            height: number;
            comment: string;
          }[],
        }),
    }).mount(photoViewerEl);
  }

  const eventLikeButtonEl = document.querySelector('event-like-button') as HTMLElement;
  const eventId = eventLikeButtonEl.dataset.eventId;
  eventStore.initLikedData([Number(eventId)]);
  createApp({
    render: () =>
      h(EventLikeButton, {
        eventId: Number(eventLikeButtonEl.dataset.eventId),
      }),
  }).mount(eventLikeButtonEl);

  const socialShareEl = document.querySelector('social-share') as HTMLElement;
  createApp({
    render: () =>
      h(SocialShare, {
        title: socialShareEl.dataset.title,
        url: socialShareEl.dataset.url,
      }),
  }).mount(socialShareEl);

  await addFollowButton();
});
